import { render, staticRenderFns } from "./setting-pay-pwd.vue?vue&type=template&id=33e5da04&scoped=true&"
import script from "./setting-pay-pwd.vue?vue&type=script&lang=js&"
export * from "./setting-pay-pwd.vue?vue&type=script&lang=js&"
import style0 from "./setting-pay-pwd.vue?vue&type=style&index=0&id=33e5da04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5da04",
  null
  
)

export default component.exports